import createReducer from '../../common/util/createReducer';
import * as ActionTypes from '../actions/actionTypes';
import {Dealer} from '../../common/actionTypes';

const INITIAL_STATE = {
  'loading': false,
  'error': '',
  'showThanksModal': false,
  'data': [],
  'editableRowIndex': -1,
  'modifiedRows': {},
  'newRows': {},
  'deletedRows': {},
  'agenciesByDealer': {},
  'invalidRowsValidation': [],
  'validationMessage': '',
};

export const commercialUsers = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.SHOW_THANKS_MODAL]: (state, action) => {
      return {
        ...state,
        'showThanksModal': action.payload,
      };
    },
    [ActionTypes.SET_EDITABLE_ROW_INDEX]: (state, action) => {
      return {
        ...state,
        'editableRowIndex': action.payload,
      };
    },
    [ActionTypes.UPDATE_USER_DATA]: (state, action) => {
      return {
        ...state,
        'data': state.data.map((row) => {
          if (row.usuario === action.payload.id) {
            return {
              ...row,
              ...action.payload.newData,
            };
          }

          return row;
        }),
        'modifiedRows': {
          ...state.modifiedRows,
          [action.payload.id]: {
            ...(state.modifiedRows[action.payload.id] ?? {}),
            ...action.payload.newData,
          },
        },
      };
    },
    [ActionTypes.ADD_NEW_USER_ROW]: (state, action) => {
      return {
        ...state,
        'data': [
          action.payload.newRow,
          ...state.data,
        ],
        'newRows': {
          ...state.newRows,
          [action.payload.id]: action.payload.newRow,
        },
      };
    },
    [ActionTypes.UPDATE_NEW_USER_DATA]: (state, action) => {
      return {
        ...state,
        'data': state.data.map((row) => {
          if (row.id === action.payload.id) {
            return {
              ...row,
              ...action.payload.newData,
            };
          }

          return row;
        }),
        'newRows': {
          ...state.newRows,
          [action.payload.id]: {
            ...(state.newRows[action.payload.id] ?? {}),
            ...action.payload.newData,
          },
        },
      };
    },
    [ActionTypes.DEACTIVATE_USER_ROW]: (state, action) => {
      if (state.newRows[action.payload.id]) {
        const auxNewRos = JSON.parse(JSON.stringify(state.newRows));
        delete auxNewRos[action.payload.id];

        return {
          ...state,
          'newRows': auxNewRos,
          'data': state.data.filter((row) => row.id !== action.payload.id),
        };
      }

      return {
        ...state,
        'deletedRows': {
          ...state.deletedRows,
          [action.payload.id]: true,
        },
      };
    },
    [Dealer.GET_ALL_AGENCIES_SUCCESS]: (state, action) => {
      return {
        ...state,
        'agenciesByDealer': {
          ...action.response.data.reduce((pv, cv) => {
            const newData = pv[cv.dealerId] ? [...pv[cv.dealerId], cv] : [cv];

            return {
              ...pv,
              [cv.dealerId]: newData,
            };
          }, {}),
        },
      };
    },
    [ActionTypes.FETCHING_COMMERCIAL_USERS]: (state, action) => {
      return {
        ...state,
        'loading': true,
      };
    },
    [ActionTypes.FETCHED_COMMERCIAL_USERS]: (state, action) => {
      return {
        ...state,
        'data': action.response.data,
        'loading': false,
      };
    },
    [ActionTypes.FETCHED_COMMERCIAL_USERS_FAILED]: (state, action) => {
      return {
        ...state,
        'loading': false,
      };
    },
    [ActionTypes.SENDING_COMMERCIAL_USERS_DATA]: (state, action) => {
      return {
        ...state,
        'loading': true,
      };
    },
    [ActionTypes.SENT_COMMERCIAL_USERS_DATA]: (state, action) => {
      return {
        ...state,
        'loading': false,
      };
    },
    [ActionTypes.SENT_COMMERCIAL_USERS_DATA_FAILED]: (state, action) => {
      return {
        ...state,
        'loading': false,
      };
    },
    [ActionTypes.SENDING_COMMERCIAL_USERS_UPDATE]: (state, action) => {
      return {
        ...state,
        'invalidRowsValidation': [],
        'validationMessage': '',
        'loading': true,
      };
    },
    [ActionTypes.SENT_COMMERCIAL_USERS_UPDATE]: (state, action) => {
      return {
        ...state,
        'invalidRowsValidation': action.response?.invalid_data || [],
        'validationMessage': action.response?.message || '',
        'loading': false,
      };
    },
    [ActionTypes.SENT_COMMERCIAL_USERS_UPDATE_FAILED]: (state, action) => {
      return {
        ...state,
        'invalidRowsValidation': [],
        'validationMessage': '',
        'loading': false,
      };
    },
    [ActionTypes.CLEAN_COMMERCIAL_USERS]: (state, action) => {
      return {
        ...state,
        'data': [],
        'editableRowIndex': -1,
        'modifiedRows': {},
        'newRows': {},
        'deletedRows': {},
        'invalidRowsValidation': [],
        'validationMessage': '',
      };
    },
  })(state, action);
};
